import React from 'react'
import style from './Complete.module.css'
import { useTranslation } from 'react-i18next'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const Complete = () => {
  const { t } = useTranslation()
  return (
    <div className={style.complete} id={'complete'}>
      <div className={`${'customContainer'} ${style.complete_wrap}`}>
        <h2 className={style.title}>{t('complete.title')}</h2>
        <p className={style.desc}>{t('complete.desc')}</p>
        <a
          href="https://www.youtube.com/watch?v=a5plyUPexio"
          target="_blank"
          rel="noopener noreferrer"
          className={style.button}
        >
          {t('complete.button')}
        </a>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
    </div>
  )
}

export default Complete
